var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label":"Fecha"}},[_c('date-picker',{attrs:{"lang":"es","format":"DD-MM-YYYY","range":"","confirm":""},model:{value:(_vm.rangeDate),callback:function ($$v) {_vm.rangeDate=$$v},expression:"rangeDate"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }